import type { FC } from 'react';
import { useState } from 'react';
import { Logo } from './logo';
import { getSidebarLogoUrl } from 'src/config';

export const SidebarLogo: FC = () => {
  const [useCustomLogo, setUseCustomLogo] = useState(true);
  const logoUrl = getSidebarLogoUrl();

  if (!useCustomLogo) {
    return <Logo />;
  }

  return (
    <img
      src={logoUrl}
      alt="Logo"
      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      onError={() => setUseCustomLogo(false)}
    />
  );
};
